<template>
  <div class="input-text text-left input-group">
    <hl-ErrorMessage v-if="error || hlGetValidationError()" :errorVariant="errorVariant">
      {{ error ? error : hlGetValidationError() }}
    </hl-ErrorMessage>

    <div class="input-group" :class="{ 'input-group-sm': size === 'sm' }">
      <div v-if="showPrepend" class="input-group-prepend">
        <span class="input-group-text" id="inputGroupPrepend">
          {{ prependContent }}
        </span>
      </div>

      <input
        :type="type"
        :value="value"
        :placeholder="placeholder"
        @input="updateValue"
        :disabled="disabled"
        class="form-control"
        :class="getErrorClass"
        :autofocus="autofocus"
        :name="nameOrLabel"
        @blur="$emit('blur')"
        v-validate="name ? hlGetValidationRule() : ''"
        :data-vv-as="label ? label : nameForValidation"
        data-vv-delay="1000"
        :data-vv-scope="vvScope"
        :autocomplete="autocomplete"
        :readonly="readonly"
      />
    </div>

    <a-Label v-if="label" :optional="optional">
      {{ label }}
    </a-Label>
  </div>
</template>

<script>
import hlValidation from '@modules/husleie-framework/src/mixins/hlValidation';
import ErrorMessage from '@modules/husleie-framework/src/components/text/ErrorMessage.vue';
import Label from '@modules/design-system/components/atoms/labels/Label.vue';

export default {
  mixins: [hlValidation],
  components: {
    'a-Label': Label,
    'hl-ErrorMessage': ErrorMessage,
  },
  props: {
    autocomplete: String,
    autofocus: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
    },
    errorVariant: {
      type: String,
      default: 'danger',
    },
    name: String,
    onlyError: {
      type: Boolean,
      default: false,
    },
    value: [String, Number],
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'lg',
    },
    vvScope: {
      type: String,
      default: undefined,
    },
    nameForValidation: {
      type: String,
    },
    showPrepend: {
      type: Boolean,
      default: false,
    },
    prependContent: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
      validator: val => {
        return ['url', 'text', 'password', 'email', 'search', 'number', 'date', 'tel', 'time'].indexOf(val) !== -1;
      },
    },
    optional: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
  },
  computed: {
    nameOrLabel() {
      if (this.name) return this.name;

      if (this.label) return encodeURIComponent(this.label).toLowerCase();

      return 'placeholder' + Math.round(Math.random() * 100000);
    },

    getErrorClass() {
      const classes = ['input'];

      if ((this.error && this.errorVariant === 'danger') || !!this.hlGetValidationError()) {
        classes.push('is-invalid');
      }

      if (this.error && this.errorVariant === 'warning') {
        classes.push('is-warning');
      }
      return classes;
    },
  },
};
</script>

<style scoped lang="scss">
.form-control.is-warning {
  border-color: $warning;
}

.input-text {
  display: flex;
  flex-direction: column-reverse;
  position: relative;

  p {
    margin-top: 1rem;
  }

  input {
    //padding-right: 45px;
  }

  label {
    font-size: 0.8em;
    color: $husleie-text-light;
  }

  input {
    &:focus {
      + label {
        color: $husleie-text-medium;
      }
    }
  }
}

.has-label {
  top: 2.6rem;
}

.no-label {
  top: 1rem;
}
</style>
